import React from 'react';
import { func, images, types } from 'utils';
import { RouteComponentProps, useParams } from 'react-router';
import { _store, _update } from '_Store';
import { useIonRouter } from '@ionic/react';
import { Dropdown, Space } from 'antd';

// const jQuery = Object(window).jQuery;

interface Params {
	id: string;
}
interface StateProps {
	categories?: any;
	showFilter?: boolean;

	onCategoryChange?: (id: string) => void;
}
interface Props extends RouteComponentProps, types.StateProps, StateProps {}

const Filter: React.FC<Props> = (props) => {
	const params: Params = useParams();
	const router = useIonRouter();

	const {
		__data: { filter, categories },
	} = _store.useState();

	React.useEffect(() => {
		var filtereD = 0;
		Object.keys(filter).forEach((of) => {
			if (
				[
					'categoriess',
					'tags',
					'drinks',
					'cuisines',
					'tags',
					'stores',
				].includes(of)
			) {
				if (filter[of].length > 0) {
					filtereD = filtereD + filter[of].length;
					console.log(`++ ${of}`);
				}
			}
			if (of === 'minPrice' && +filter[of] > 0) {
				filtereD++;
				console.log('++ minPrice');
			}
			if (
				of === 'maxPrice' &&
				filter[of] &&
				+filter[of].toString().replace(',', '') > 0
			) {
				filtereD++;
				console.log('++ maxPrice', filter[of]);
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filter]);

	const activeCategory = (props.categories || categories || []).find(
		(ctg: types.Category) => ctg.id === params.id
	);

	return (
		<React.Fragment>
			{(props.categories || categories || []).length > 0 && (
				<div
					id="Filter"
					className="d-flex py-2 px-3 justify-content-center justify-content-between stickys"
				>
					<div>
						<Dropdown
							menu={{
								items: (props.categories || categories || []).map(
									(ctg: types.Category) => {
										return {
											key: ctg.id,
											label: ctg.name,
											style: {
												borderBottom: '1px solid #ebeff6',
												padding: '.8rem 1rem',
											},
										};
									}
								),
								style: {
									padding: 0,
								},
								onClick: (info) => {
									const selectedCategory = (
										props.categories ||
										categories ||
										[]
									).find((ctg: types.Category) => ctg.id === info.key);
									if (selectedCategory) {
										if (props.onCategoryChange) {
											props.onCategoryChange(selectedCategory.id);
										} else {
											_update.data('filter', {
												categories: [selectedCategory.id],
											});
											router.push(
												`/c/${func.seourl(selectedCategory.name)}.${selectedCategory.id}`
											);
										}
									}
								},
							}}
							trigger={['click']}
							overlayStyle={{
								border: '2px solid #ff1200',
								borderRadius: 6,
								marginTop: 6,
							}}
						>
							<div
								className="btn btn-primary tt-none"
								style={{ height: 'auto' }}
							>
								<Space>
									<small className="fw-600">
										{activeCategory
											? activeCategory.name.substring(0, 25)
											: 'Select a category'}
									</small>
									<img src={images.ArrowDown} alt="ArrowDown" />
								</Space>
							</div>
						</Dropdown>
					</div>
				</div>
			)}
		</React.Fragment>
	);
};

export default Filter;
